import AutogestionLogDelete from './AutogestionLogDelete'
export {AutogestionLogDelete}
export default AutogestionLogDelete
